const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

async function apiFetch(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: "Request failed" }));
    const apiError = new Error(error.message || `API error: ${response.status}`);
    apiError.status = response.status;
    apiError.details = error;
    throw apiError;
  }

  return response.json();
}

export async function fetchAvailability(start, end) {
  return apiFetch(`/api/availability?start=${start}&end=${end}`);
}

export async function submitContactMessage({ email, message }) {
  return apiFetch("/api/submit-booking-request", {
    method: "POST",
    body: JSON.stringify({ type: "contact-message", email, message }),
  });
}

// Meta Conversions API — server-side mirror of a browser Pixel event.
export async function sendConversionEvent(payload) {
  return apiFetch("/api/meta-conversion", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function submitBookingRequest({ checkIn, checkOut, guestInfo, pricing }) {
  return apiFetch("/api/submit-booking-request", {
    method: "POST",
    body: JSON.stringify({ checkIn, checkOut, guestInfo, pricing }),
  });
}

export async function getBooking(bookingId) {
  return apiFetch(`/api/booking?id=${bookingId}`);
}

export async function createPaypalOrder({ bookingId }) {
  return apiFetch("/api/create-paypal-order", {
    method: "POST",
    body: JSON.stringify({ bookingId }),
  });
}

export async function logPaypalClientEvent(bookingId, clientEvent) {
  return apiFetch("/api/create-paypal-order", {
    method: "POST",
    body: JSON.stringify({ bookingId, clientEvent }),
  });
}

export async function capturePaypalOrder(orderId) {
  return apiFetch("/api/capture-paypal-order", {
    method: "POST",
    body: JSON.stringify({ orderId }),
  });
}

// Admin API helpers
function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export async function adminLogin(password) {
  return apiFetch("/api/admin/login", {
    method: "POST",
    body: JSON.stringify({ password }),
  });
}

export async function adminGetBookings(token) {
  return apiFetch("/api/admin/bookings", {
    headers: authHeaders(token),
  });
}

export async function adminUpdateBooking(token, bookingId, action) {
  return apiFetch("/api/admin/bookings/update", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ bookingId, action }),
  });
}

export async function adminCreateTestPayment(token) {
  return apiFetch("/api/admin/bookings/update", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ action: "create-test-payment" }),
  });
}

export async function adminGetBlockedDates(token) {
  return apiFetch("/api/admin/blocked-dates", {
    headers: authHeaders(token),
  });
}

export async function adminBlockDates(token, { action, start, end, reason }) {
  return apiFetch("/api/admin/blocked-dates", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ action, start, end, reason }),
  });
}

export async function fetchPricing() {
  return apiFetch("/api/pricing");
}

export async function adminUpdatePricing(token, pricing) {
  return apiFetch("/api/admin/pricing", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify(pricing),
  });
}
